// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"64":"137fd206a97b4d1e","253":"e500ad59fb5b09ba"}[chunkId] + ".js";
};